<template>
  <div class="table-responsive">
    <b-table
      striped
      hover
      fixed
      head-variant="dark"
      show-empty
      responsive
      :busy="loading"
      :empty-text="emptyText"
      :fields="tableFields"
      :items="canRead(access) ? rows : []"
      style="border-radius: 10px; overflow: scroll; max-height: 500px;"
    >
      <template v-slot:table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner variant="success" size="sm" class="align-middle"></b-spinner>
        </div>
      </template>
      <template v-slot:cell(action)="row">
        <div class="text-center">
          <button-options
            :access="access"
            :hideAdd="true"
            :hideDelete="false"
            :hideDetail="true"
            :hideEdit="false"
            @onEditClicked="$emit('edit', row.item)"
            @onDeleteClicked="$emit('delete', row.item)"
          />
        </div>
      </template>
    </b-table>
    <b-pagination
      :value="pagination.current"
      :per-page="pagination.pageSize"
      :total-rows="pagination.totalSize"
      @change="$emit('page-change', $event)"
    ></b-pagination>
  </div>
</template>

<script>
import ButtonOptions from '@/components/directives/button-options';

export default {
  name: 'MasterTable',
  components: { ButtonOptions },
  props: {
    access: { type: String, required: true },
    columns: { type: Array, required: true },
    rows: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    pagination: { type: Object, required: true },
    emptyText: { type: String, default: 'No data available.' },
  },
  computed: {
    hasRowActions() {
      return this.canUpdate(this.access) || this.canDelete(this.access);
    },
    tableFields() {
      const fields = this.columns.map((col) => {
        const field = {
          key: col.key,
          label: col.label,
          class: `text-${col.align || 'left'}`,
        };
        if (col.sortable) field.sortable = true;
        if (col.width) field.thStyle = { width: col.width };
        if (col.formatter || col.map) {
          field.formatter = (value, key, item) => this.renderCell(col, value, key, item);
        }
        return field;
      });
      if (this.hasRowActions) {
        fields.push({ key: 'action', label: '', class: 'text-center' });
      }
      return fields;
    },
  },
  methods: {
    renderCell(col, value, key, item) {
      if (value === null || value === undefined || value === '') return '-';
      if (col.map) return col.map[value] !== undefined ? col.map[value] : value;
      return col.formatter(value, key, item);
    },
  },
};
</script>
